import HomeRepayCreditFormOnRamp from "../forms/HomeRepayCreditFormOnRamp";
import {AvailableBalance} from "../../utils/creditService";

interface HomeRepayCreditModalViewOnRampProps {
  onCloseModal: () => void;
  handleBack: () => void;
  creditLine: AvailableBalance;
}

function HomeRepayCreditModalViewOnRamp(
  {
    onCloseModal,
    handleBack
  }:HomeRepayCreditModalViewOnRampProps) {

  return (
    <HomeRepayCreditFormOnRamp
      onCloseModal={onCloseModal}
      handleBack={handleBack}/>
  );
}

export default HomeRepayCreditModalViewOnRamp;